import api from './api';

// Adaptador de subida de imagenes para CKEditor.
//
// Sin adaptador el editor no sabe que hacer con una imagen: la descarta, tanto
// si viene del boton de insertar como si se pega o se arrastra. Lo usan los
// editores de descripcion, donde se espera que entren capturas y gifs.
//
// Estaba escrito a mano dentro de create-project. Vive aqui porque project-edit
// necesita exactamente el mismo, y duplicar un plugin con closure es la clase de
// cosa que acaba arreglandose en un sitio y no en el otro.

// extraPlugins espera constructores: CKEditor hace `new Plugin(editor)`, asi que
// tiene que ser una clase y no una arrow function.
//
// getCompanyId es una funcion, no el valor: la compania se conoce despues del
// primer render (llega de la API o de los params de la ruta) y el adaptador la
// lee en el momento de subir, no al construirse.
export const createUploadAdapterPlugin = (getCompanyId) => (
	class CKUploadAdapterPlugin {
		constructor(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => ({
				upload: async () => {
					const file = await loader.file;
					const form = new FormData();
					form.append('file', file);

					try {
						const response = await api.post(
							`companies/${getCompanyId()}/assets/upload`,
							form
						);

						return {default: response.data.url};
					} catch (error) {
						// El texto del reject es lo que CKEditor enseña en su aviso, asi
						// que tiene que leerse como un mensaje, no como un error tecnico.
						console.log(error);
						return Promise.reject('Image upload failed. Please try again.');
					}
				},
				abort: () => {}
			});
		}
	}
);

// La config se construye una sola vez por componente y se guarda en un campo de
// clase. Si se crea dentro del render, CKEditor recibe un objeto nuevo en cada
// pulsacion, se reinicializa y el cursor salta.
export const uploadEditorConfig = (getCompanyId) => ({
	extraPlugins: [createUploadAdapterPlugin(getCompanyId)]
});
